// extracted by mini-css-extract-plugin
module.exports = {"color-danger":"styles_color-danger__iJxeY","background-color-secondary":"styles_background-color-secondary__CsZTs","input":"styles_input__oVXsX"};